export default {"src":"/_next/static/media/visibility-on.623bd04f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};